import { TranscriptEntry } from './index';

export type { TranscriptEntry };

export interface AICoachingMessage {
	id: string;
	text: string;
	timestamp: Date;
	isStreaming: boolean;
}

export interface TysonCoachingContextData {
	phoneCallId?: string;
	companyId: string;
	leadServedId?: string; // Optional for practice calls (tyson-practice mode)
	contactId: string;
	objectivePrompt?: string; // Coaching system prompt from backend
}

export interface TranscriptBatch {
	entries: TranscriptEntry[];
	timestamp: Date;
}

export const TYSON_ASSISTANT_NAME = 'SalesLiveCoachingAssistant';

export const TYSON_COACHING_FALLBACK_PROMPT = `You are an expert sales coach providing real-time guidance during a practice sales call.

Your role:
- Provide concise, actionable suggestions as the conversation unfolds
- Highlight what the sales rep is doing well
- Suggest specific improvements when the rep misses opportunities
- Be encouraging but direct
- Focus on practical next steps the rep can take RIGHT NOW

Format your coaching as brief, scannable suggestions. Use markdown for emphasis.`;

export const TYSON_END_OF_CALL_SUMMARY_PROMPT = `The practice call has ended. Based on the entire conversation transcript and our training materials, please provide a comprehensive summary:

## What Went Well
- Highlight 2-3 specific things the SDR did effectively

## Areas for Improvement
- Identify 2-3 specific areas where the SDR could improve
- Reference relevant techniques from our training materials

## Focus for Next Call
- Provide 1-2 actionable items to practice on the next call

Be specific and reference actual moments from the call.`;
